"use client";

import { SignOutButton } from "@clerk/react";
import { Button, type SxProps, type Theme } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import { type FC } from "react";

interface IAppSignOutButtonProps {
  name?: string;
  sx?: SxProps<Theme>;
  onClick?: () => void;
}

export const AppSignOutButton: FC<IAppSignOutButtonProps> = ({
  name = "Log Out",
  sx,
  onClick,
}) => {
  const theme = useTheme();

  const buttonVariant =
    theme.palette.mode === "dark" ? "outlined" : "contained";

  return (
    <SignOutButton>
      <Button
        size="small"
        variant={buttonVariant}
        color="primary"
        sx={sx}
        onClick={onClick}
      >
        {name}
      </Button>
    </SignOutButton>
  );
};
